// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"49b5bd0a","1299":"7c2526e5","1640":"4ec04076","6361":"89eac827","7568":"44c239a7","8631":"bc775fd5"}[chunkId] + ".chunk.css";
};